import { EBAY, ETSY, FAIRE, SHOPIFY } from '@/constants/channels';
import { FORM, FORM_TITLE } from '@/constants/forms';

export const THUMBNAIL_SIZE = 42;

export const ALL = 'all';

export const PAGE_SIZE = 10;

export const PROFILE_TYPE = {
  AI: 'ai',
  STANDARD: 'standard',
};

export const PROFILE_TYPES = [
  PROFILE_TYPE.STANDARD,
  PROFILE_TYPE.AI,
];

export const PROFILE_TYPE_NAME = {
  [PROFILE_TYPE.AI]: 'AI',
  [PROFILE_TYPE.STANDARD]: 'Standard',
};

export const SAVE_TYPE = {
  UPDATE_PROFILE: 'Update current profile',
  SAVE_AS_NEW: 'Save as new profile',
};

export const SAVE_OPTIONS = [
  SAVE_TYPE.UPDATE_PROFILE,
  SAVE_TYPE.SAVE_AS_NEW,
];

export const PLACEHOLDERS = {
  SHOPS: 'Select shops',
  PROFILE_NAME: 'Enter Profile name',
};

export const SECTION_LABEL = {
  [ALL]: 'All',
  ...FORM_TITLE,
};

export const SECTIONS = {
  [EBAY]: {
    [PROFILE_TYPE.AI]: [
      FORM.TITLE,
      FORM.DESCRIPTION,
    ],
    [PROFILE_TYPE.STANDARD]: [
      FORM.PHOTOS,
      FORM.VIDEOS,
      FORM.TITLE,
      FORM.DESCRIPTION,
      FORM.DETAILS,
      FORM.PRICING,
      FORM.INVENTORY,
      FORM.VARIATIONS,
      FORM.SHIPPING,
    ],
  },
  [ETSY]: {
    [PROFILE_TYPE.AI]: [
      FORM.TITLE,
      FORM.DESCRIPTION,
      FORM.TAGS,
    ],
    [PROFILE_TYPE.STANDARD]: [
      FORM.PHOTOS,
      FORM.VIDEOS,
      FORM.TITLE,
      FORM.DESCRIPTION,
      FORM.TAGS,
      FORM.DETAILS,
      FORM.PRICING,
      FORM.INVENTORY,
      FORM.VARIATIONS,
      FORM.PERSONALIZATION,
      FORM.SHIPPING,
      FORM.FILES,
    ],
  },
  [FAIRE]: {
    [PROFILE_TYPE.AI]: [
      FORM.TITLE,
      FORM.DESCRIPTION,
    ],
    [PROFILE_TYPE.STANDARD]: [
      FORM.PHOTOS,
      FORM.TITLE,
      FORM.DESCRIPTION,
      FORM.DETAILS,
      FORM.PRICING,
      FORM.INVENTORY,
      FORM.VARIATIONS,
      FORM.SHIPPING,
    ],
  },
  [SHOPIFY]: {
    [PROFILE_TYPE.AI]: [
      FORM.TITLE,
      FORM.DESCRIPTION,
      FORM.SEO,
    ],
    [PROFILE_TYPE.STANDARD]: [
      FORM.PHOTOS,
      FORM.VIDEOS,
      FORM.TITLE,
      FORM.DESCRIPTION,
      FORM.TAGS,
      FORM.DETAILS,
      FORM.PRICING,
      FORM.INVENTORY,
      FORM.VARIATIONS,
      FORM.SHIPPING,
      FORM.SEO,
    ],
  },
};

export const ERRORS = {
  SAME_NAME_PROFILE: 'You may not have two profiles with same name',
};

export const MESSAGES = {
  CONNECTED_LISTINGS: 'All content included in this profile will overwrite those same sections for listings connected to this profile. Once connected, these changes cannot be reverted, but they can be overwritten by updating the profile.',
};
